import React, { useState } from 'react';
import { RiMenu3Line, RiCloseLine } from 'react-icons/ri';
import { NavLink, Link } from 'react-router-dom';
import logo1 from '../../assets/logo-good.jpg';
import './navbar.css';

const Navbar = () => {
  const [toggleMenu, setToggleMenu] = useState(false);

  const navItems = [
    { id: 'home', label: 'Home', path: '/' },
    { id: 'events', label: 'Events', path: '/events' },
    { id: 'team', label: 'Team', path: '/team' },
    { id: 'testimonials', label: 'Testimonials', path: '/gallery' },
    { id: 'contact', label: 'Contact Us', path: '/contact' },
  ];

  const handleNavClick = () => {
    setToggleMenu(false);
    window.scrollTo(0, 0);
  };

  return (
    <nav className="gpt3__navbar">
      <div className="gpt3__navbar-links">
        <div className="gpt3__navbar-links_logo">
          <Link 
            to="/"
            onClick={handleNavClick}
            className="gpt3__navbar-logo-btn"
            aria-label="Bollywood Ki Dhun home"
          >
            <img src={logo1} alt="Bollywood Ki Dhun logo" />
          </Link>
        </div>
        <div className="gpt3__navbar-links_container">
          {navItems.map((item) => (
            <p key={item.id}>
              <NavLink
                to={item.path}
                onClick={handleNavClick}
                className={({ isActive }) => `gpt3__navbar-link ${isActive ? 'active' : ''}`}
              >
                {item.label}
              </NavLink>
            </p>
          ))}
        </div>
      </div>
      <div className="gpt3__navbar-menu">
        {toggleMenu
          ? <RiCloseLine color="#f4ebff" size={27} onClick={() => setToggleMenu(false)} />
          : <RiMenu3Line color="#f4ebff" size={27} onClick={() => setToggleMenu(true)} />}
        {toggleMenu && (
        <div className="gpt3__navbar-menu_container scale-up-center">
          <div className="gpt3__navbar-menu_container-links">
            {navItems.map((item) => (
              <p key={item.id}>
                <NavLink
                  to={item.path}
                  onClick={handleNavClick}
                  className={({ isActive }) => `gpt3__navbar-link ${isActive ? 'active' : ''}`}
                >
                  {item.label}
                </NavLink>
              </p>
            ))}
          </div>
        </div>
        )}
      </div>
    </nav>
  );
};

export default Navbar;
